<template>
  <div>
    <v-top-bar />

    <div class="p-3">
      <router-view
        :key="$route.fullPath"
      />
    </div>
  </div>
</template>

<script>

import TopBar from '@/admin/components/TopBar.vue';
import { mapGetters } from 'vuex';
import { pageNotFound } from '@/common/utils/notify';

export default {
  name: 'AdminBase',
  components: {
    'v-top-bar': TopBar,
  },
  computed: {
    ...mapGetters(['user']),
  },
  created() {
    if (!this.user.su) {
      pageNotFound();
      this.$router.push({ name: 'dashboard' });
    }
  },
};
</script>
